export default "__VITE_ASSET__DHMU06tl__"